import React from 'react';
import { Snackbar, Alert } from '@mui/material';

/**
 * Reusable Toast Notification Component
 * Usage: 
 * const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
 * <Toast toast={toast} setToast={setToast} />
 * setToast({ open: true, message: 'Success!', severity: 'success' });
 */
const Toast = ({ toast, setToast, open, message, severity, handleClose: customHandleClose }) => {
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        if (customHandleClose) {
            customHandleClose(event, reason);
        } else if (setToast && toast) {
            setToast({ ...toast, open: false });
        }
    };

    const isOpen = toast ? Boolean(toast.open) : Boolean(open);
    const msg = toast?.message ?? message ?? '';
    const sev = toast?.severity ?? severity ?? 'success';
    const duration = toast?.duration ?? 3000;

    return (
        <Snackbar
            open={isOpen}
            autoHideDuration={duration}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                onClose={handleClose}
                severity={sev}
                variant="filled"
                sx={{
                    width: '100%',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                }}
            >
                {msg}
            </Alert>
        </Snackbar>
    );
};

export default Toast;
